import { Box, Skeleton, Stack } from '@/primitives';
import { slate } from '@/lib/colours';

interface Props {
  isBrief?: boolean;
  landing?: boolean;
}

export default function NewsCardSkeleton({ isBrief, landing }: Props) {
  const inner = (
    <Stack
      sx={{
        display: 'flex',
        flexDirection: isBrief ? 'row' : 'column',
        maxWidth: { xs: 'unset', md: '378px' },
      }}
    >
      <Skeleton
        sx={{
          borderRadius: isBrief ? (landing ? '10px 0 0 10px' : 0) : '12px',
          height: {
            sm: isBrief ? '96px' : 'unset',
          },
          width: {
            sm: isBrief ? '96px' : '100%',
          },
          aspectRatio: isBrief
            ? '1 / 1'
            : {
                xs: '350 / 300',
                md: '336 / 260',
              },
          transform: 'none',
          bgcolor: landing ? slate[800] : undefined,
        }}
      />
      <Stack
        sx={{
          flex: 1,
          justifyContent: 'center',
          p: isBrief ? '0 16px !important' : '12px 0 !important',
        }}
      >
        <Skeleton
          sx={{
            width: '75%',
            lineHeight: '24px',
            bgcolor: landing ? slate[800] : undefined,
          }}
        />
        <Skeleton
          sx={{
            mt: isBrief ? 0 : '4px',
            width: '100%',
            lineHeight: isBrief ? '24px' : '20px',
            bgcolor: landing ? slate[800] : undefined,
          }}
        />
        <Skeleton
          sx={{
            mt: isBrief ? 0 : '8px',
            height: '20px',
            width: '25%',
            bgcolor: landing ? slate[800] : undefined,
          }}
        />
      </Stack>
    </Stack>
  );

  if (landing) {
    return (
      <Box
        sx={{
          borderRadius: '14px',
          border: `1px solid ${slate[800]}`,
          backgroundColor: slate[900],
          overflow: 'hidden',
          p: isBrief ? 0 : 0,
        }}
      >
        {inner}
      </Box>
    );
  }

  return inner;
}
